import React from "react";

const PhotoGallery = () => {
  return (
    <div>
      <div class="row">
        <div class="col-lg-4 col-md-12 mb-4 mb-lg-0">
          <img
            src="../../1.png"
            class="w-100 shadow-1-strong rounded mb-4"
            alt="Boat on Calm Water"
          />

          <img
            src="../../3.png"
            class="w-100 shadow-1-strong rounded mb-4"
            alt="Wintry Mountain Landscape"
          />

          <img
            src="../../4.png"
            class="w-100 shadow-1-strong rounded mb-4"
            alt="Boat on Calm Water"
          />
        </div>

        <div class="col-lg-4 mb-4 mb-lg-0">
          <img
            src="../../4.png"
            class="w-100 shadow-1-strong rounded mb-4"
            alt="Mountains in the Clouds"
          />

          <img
            src="../../5.png"
            class="w-100 shadow-1-strong rounded mb-4"
            alt="Boat on Calm Water"
          />

          <img
            src=".../../3.png"
            class="w-100 shadow-1-strong rounded mb-4"
            alt="Wintry Mountain Landscape"
          />
        </div>

        <div class="col-lg-4 mb-4 mb-lg-0">
          <img
            src="../../1.png"
            class="w-100 shadow-1-strong rounded mb-4"
            alt="Waves at Sea"
          />

          <img
            src="../../Beti-Bachao-Beti-Padhao-Yojana.png"
            class="w-100 shadow-1-strong rounded mb-4"
            alt="Yosemite National Park"
          />

          <img
            src="../../1.png"
            class="w-100 shadow-1-strong rounded mb-4"
            alt="Boat on Calm Water"
          />
        </div>

        {/* <div class="row">
            <div class="col-lg-4 col-md-12 mb-4 mb-lg-0">
              <img
                src="../../Janani-shishu-suraksha-karyakram-jssk.png"
                class="w-100 shadow-1-strong rounded mb-4"
                alt="Boat on Calm Water"
              />

              <img
                src=".../../Kishori shakti.png"
                class="w-100 shadow-1-strong rounded mb-4"
                alt="Wintry Mountain Landscape"
              />
            </div>
            </div>
            <div class="row">
              <div class="col-lg-4 mb-4 mb-lg-0">
                <img
                  src="../../Balika-Samriddhi-Scheme.png"
                  class="w-100 shadow-1-strong rounded mb-4"
                  alt="Mountains in the Clouds"
                />

                <img
                  src="../../Kishori shakti.png"
                  class="w-100 shadow-1-strong rounded mb-4"
                  alt="Boat on Calm Water"
                />
              </div>
            </div> */}

        {/* <div class="col-lg-4 mb-4 mb-lg-0">
    <img
      src="../../1.png"
      class="w-100 shadow-1-strong rounded mb-4"
      alt="Waves at Sea"
    />

    <img
      src="../../Vhaali_Dikri_Yojana.png"
      class="w-100 shadow-1-strong rounded mb-4"
      alt="Yosemite National Park"
    />
  </div> */}
      </div>
    </div>
  );
};

export default PhotoGallery;
